import { owcTheme } from 'core/theme/theme.config';
import { PocCard } from 'commons/components/components-wrapper/poc-card.component';
import { PocRadioGroup } from 'commons/components/components-wrapper/poc-radio-group.component';
import { Input, InputFileUploader, TypographyBody1, WorkflowOverlayComponent } from 'commons/components';
import styled from 'styled-components';
import { fileTypeAcceptedForCertificates } from './settings-devices-eap-settings-form.constants';

export const EapWorkflowOverlayComponent = styled(WorkflowOverlayComponent)`
    div[slot='content'] {
        display: flex;
        flex-direction: column;
        overflow: auto;
        background-color: ${owcTheme['one-color-gray-50']};
    }
`;

export const EapFormContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    align-items: center;
    padding: 2rem;
`;

export const EapFormTitle = styled(TypographyBody1)`
    margin-bottom: 0.5rem;
    font-weight: 500 !important;
    color: ${owcTheme['one-color-foreground-base']}!important;
`;

/* OWC-OVERRIDE: fill the form row. owc-input has a fixed ~250px default width on its host and
   no width prop in v7.6.0; matching its own class raises specificity enough to win. */
export const EapOwcInput = styled(Input).attrs({ noClearIcon: false, spaceForError: true })`
    &.owc-input {
        width: 100%;
    }
`;

export const EapInputFileUploader = styled(InputFileUploader).attrs({
    accept: fileTypeAcceptedForCertificates.join(','),
})`
    margin-bottom: 1.5rem;
`;

export const EapPocRadioGroup = styled(PocRadioGroup)`
    margin-bottom: 1.5rem;
`;

/* OWC-OVERRIDE: stack the form fields with the card's v6 padding. owc-card's content wrapper
   is a plain block with zero padding in v7.6.0 and exposes no layout or padding prop. */
export const EapFormCard = styled(PocCard)`
    .owc-card__content-wrapper {
        display: flex;
        flex-direction: column;
        min-width: 600px;
        padding: 1rem 1.5rem;
    }
`;

export const EapFormCardContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
`;
